/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url:  '/home',
    name: "Dashboard",
    icon: "HomeIcon",
    i18n: "Accueil",
    slug: "app-home", 
  },
  
  {
    header: "formations",
    icon: "PackageIcon",
    i18n: "formation",
    items: [
      {
        url: '/formation',
        name: "toutes formations",
        i18n: "toutes formations",
        slug: "app-formation",
        icon: "ListIcon",
      },
      {
        url: '/nouveaus_formations',
        name: "nouveaus formations",
        i18n: "nouveaus formations",
        slug: "app-formation",
        icon: "ListIcon",
      },
      

    ]},    
    {
      header: "domaines",
      icon: "PackageIcon",
      i18n: "domaines",
      items: [
        {
          url: '/domaine',
          name: "toutes domaines",
          i18n: "toutes domaines",
          slug: "app-domaine",
          icon: "ListIcon",
        },
        {
          url: '/nouveaus_domaines',
          name: "nouveaus domaines",
          i18n: "nouveaus domaines",
          slug: "app-domaine",
          icon: "ListIcon",
        },
        
  
      ]},
      
  
  
  
]

